import { render } from "./DefaultCellRenderer.vue?vue&type=template&id=161e32ad&ts=true"
import script from "./DefaultCellRenderer.vue?vue&type=script&lang=ts"
export * from "./DefaultCellRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\victo\\Documents\\Projects\\RawData\\product-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__